import { onDOMLoaded } from './util/misc.js'

let imgWrapParent, imgWrap

onDOMLoaded(() => {
  imgWrapParent = document.querySelector('.js-get-height')
  imgWrap = document.querySelector('.js-get-img-height')

  setContentContainerHeight(imgWrapParent, imgWrap)
})

window.addEventListener('resize', () => {
  setContentContainerHeight(imgWrapParent, imgWrap)
}, true)

function setContentContainerHeight(imgWrapParent, imgWrap) {
  let content_container = document.querySelector('.js-calc-content-height')

  if(!content_container && !imgWrapParent && !imgWrap) return

  if(window.matchMedia('(min-width: 768px)').matches) {
    let imgParentHeight = imgWrapParent.clientHeight,
        imgHeight = imgWrap.clientHeight,
        contentHeight = imgHeight - imgParentHeight

    content_container.style.minHeight = (contentHeight + 48) + 'px'
  } else {
    content_container.style.minHeight = 'auto'
  }
}



// WEBPACK FOOTER //
// ./scripts/single.js